(() => {
  const fieldNames = [
    "Legal business name",
    "Shop / trading name",
    "name",
    "email",
    "Shop website or storefront link",
    "phone",
    "Storefront address",
    "Resale / sales-tax registration number",
    "Issuing state / jurisdiction",
    "Billing contact and address",
    "Shipping contact and address",
    "body",
  ].map((name) => `contact[${name}]`);
  const lifetime = 15 * 60 * 1000;
  const maxFieldLength = 8000;
  const maxSnapshotLength = fieldNames.length * maxFieldLength + 2048;

  function initialize(root) {
    root.querySelectorAll("[data-wholesale-retention]").forEach((marker) => {
      const form = marker.closest("form");
      if (!form || form.dataset.retentionReady) return;
      form.dataset.retentionReady = "true";
      const key = `hc-wholesale-retry-v1:${window.location.pathname}:${form.id}`;
      try {
        const raw = window.sessionStorage.getItem(key);
        window.sessionStorage.removeItem(key);
        if (
          marker.dataset.formState === "error" &&
          raw &&
          raw.length <= maxSnapshotLength
        ) {
          const snapshot = JSON.parse(raw);
          const age = Date.now() - snapshot.submittedAt;
          if (
            typeof snapshot.submittedAt === "number" &&
            Number.isFinite(age) &&
            age >= 0 &&
            age <= lifetime &&
            snapshot.values &&
            typeof snapshot.values === "object" &&
            !Array.isArray(snapshot.values)
          ) {
            fieldNames.forEach((name) => {
              const field = form.elements.namedItem(name);
              const value = snapshot.values[name];
              if (
                field &&
                !field.value &&
                typeof value === "string" &&
                value.length <= maxFieldLength
              ) {
                field.value = value;
              }
            });
          }
        }
      } catch {
        // Native submission stays available when session storage is unavailable.
      }
      form.addEventListener("submit", () => {
        if (!form.checkValidity()) return;
        try {
          const values = {};
          fieldNames.forEach((name) => {
            const field = form.elements.namedItem(name);
            if (field) values[name] = field.value.slice(0, maxFieldLength);
          });
          const snapshot = JSON.stringify({ submittedAt: Date.now(), values });
          if (snapshot.length <= maxSnapshotLength) {
            window.sessionStorage.setItem(key, snapshot);
          } else {
            window.sessionStorage.removeItem(key);
          }
        } catch {
          // Retention is optional; never intercept the native contact request.
        }
      });
      // Mirror native validity as aria-invalid, as the contact form does.
      form.addEventListener(
        "invalid",
        (event) => event.target.setAttribute("aria-invalid", "true"),
        true,
      );
      form.addEventListener("input", (event) => {
        const field = event.target;
        if (
          field.getAttribute?.("aria-invalid") === "true" &&
          field.validity?.valid
        ) {
          field.removeAttribute("aria-invalid");
        }
      });
    });
  }

  initialize(document);
  document.addEventListener("shopify:section:load", (event) =>
    initialize(event.target),
  );
})();
